export default {
  computed: {
    scenarioBoxId () {
      if (!this.flashcardId) return null;
      const groupings = this.$store.getters['groupings/list'];
      const scenarioBoxGroupings = groupings.filter(g => {
        return g.groupingType === 'Scenario Box' && g.assetAssociations.some(aa => aa.assetBType === 'V3Flashcard' && aa.assetBId === this.flashcardId);
      }) || [];

      if (!scenarioBoxGroupings.length) return null;
      const scenarioBoxGrouping = scenarioBoxGroupings[0];
      return scenarioBoxGrouping.assetAssociations.find(aa => aa.assetBType === 'Topic').assetBId;
    },
    scenarioBoxTopic() {
      return this.$store.getters['topics/topics'][this.scenarioBoxId];
    },
    scenarioBoxGroupings() {
      return this.$store.getters['groupings/list'].filter(g => g.groupingType === 'Scenario Box');
    },
    scenarioBoxGroupedByFlashcards() {
      return this.scenarioBoxGroupings.reduce((groupedByFlashcards, grouping) => {
        const flashcardIds = grouping.assetAssociations.filter(aa => aa.assetBType === 'V3Flashcard').map(aa => aa.assetBId);
        flashcardIds.forEach(flashcardId => {
          if (!groupedByFlashcards[flashcardId]) groupedByFlashcards[flashcardId] = [];
          groupedByFlashcards[flashcardId].push(grouping);
        });
        return groupedByFlashcards;
      }, {});
    },
  },
  methods: {
    getScenarioBoxTopicId(flashcardId) {
      try {
        if (!flashcardId) return null;
        const scenarioBoxGrouping = this.scenarioBoxGroupedByFlashcards?.[flashcardId]?.[0];
        if (!scenarioBoxGrouping) return null;
        return scenarioBoxGrouping.assetAssociations.find(aa => aa.assetBType === 'Topic').assetBId;
      } catch (error) {
        console.error('Error in getScenarioBoxTopicId:', {
          error: error.message,
          stack: error.stack,
          flashcardId,
          scenarioBoxGroupedByFlashcards: this.scenarioBoxGroupedByFlashcards,
          scenarioBoxGrouping: this.scenarioBoxGroupedByFlashcards?.[flashcardId]?.[0],
          assetAssociations: this.scenarioBoxGroupedByFlashcards?.[flashcardId]?.[0]?.assetAssociations,
          method: 'getScenarioBoxTopicId',
          component: this.$options?.name || 'Unknown',
        });
        return null;
      }
    },
  },
};
